import {Component, inject, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ModalService} from '@core/services';

export interface NameDescriptionFormResult {
  id?: string | number;
  name: string;
  description?: string;
}

@Component({
  selector: 'core-name-description-form',
  imports: [
    FormsModule,
  ],
  templateUrl: './name-description-form.html',
  standalone: true,
  host: {
    style: 'width: 100%;display:flex;flex-direction:column;gap:1.25rem;'
  }
})
export class NameDescriptionForm {
  @Input() title = 'Formulario';
  @Input() entityId?: string | number;
  @Input() name = '';
  @Input() description = '';
  @Input() nameLabel = 'Nombre';
  @Input() namePlaceholder = 'Escribe un nombre';
  @Input() descriptionLabel = 'Descripción';
  @Input() descriptionPlaceholder = 'Describe el alcance';
  @Input() saveText = 'Guardar';
  @Input() cancelText = 'Cancelar';

  errorMessage = '';

  private readonly modal = inject(ModalService);

  close() {
    this.modal.closeTop();
  }

  save() {
    const normalizedName = this.name.trim();
    if (!normalizedName) {
      this.errorMessage = 'El nombre es obligatorio.';
      return;
    }

    this.modal.closeTop<NameDescriptionFormResult>({
      id: this.entityId,
      name: normalizedName,
      description: this.description.trim() || undefined,
    });
  }
}
